export const BASE_URL = process.env.REACT_APP_API_URL;
export const TARGET_URL = process.env.REACT_APP_HOME_TARGET;
export const GOOGLE_ANALYTICS_MEASURMENTID = 'G-5614DH9T6V';
